import { render } from "./BehaviorCard.vue?vue&type=template&id=185aa8ba&scoped=true"
import script from "./BehaviorCard.vue?vue&type=script&lang=js"
export * from "./BehaviorCard.vue?vue&type=script&lang=js"

import "./BehaviorCard.vue?vue&type=style&index=0&id=185aa8ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185aa8ba"]])

export default __exports__